import React from "react";
import  { useState, useEffect } from 'react';
import './classes/AgencyFinancialServices.css';
import { Link, useNavigate,useParams,useLocation } from 'react-router-dom';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';
import SalespersonSidebar from "./SalespersonSidebar";

const AgencyFinancialServices = () => {

    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        Promise.all([
        
        ])
        .then(() => {
        setIsLoading(false);
        })
     
    },[]);

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <div id="main" className="agency-financial-services-main">
                    <Helmet><title>Pro Athlete Financial Services - SMWW Sports Agency</title></Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                        <div className="agency-financial-services-container">
                            <h1>Pro Athlete Financial Services&nbsp;</h1>
                            <p>
                                <img class="imgfulli agency-financial-services-image" src="/basic/web/images/agent/shutterstock_210386878.jpg" />
                            </p>
                            <p>According to a 2020&nbsp;Sports Illustrated article, 60% of former NBA players, 78% of NFL players, and 63% of EPL players&nbsp;have either gone bankrupt, or are under financial stress within five years of retirement. By simply spending too much of their income, many pro athletes are shocked by harsh economic realities after years of living the high life. Where were their Agents? Why didn't he or she prevent this?
                            </p>
                            <h2><b>Average Length of Your Professional Career</b></h2>
                            <p>
                                You are young and excited about your first paychecks. You should be. You have worked hard to receive them. The average career of a&nbsp;football&nbsp;
                                player is 3.3 years, the average career of a soccer player is 5.2 years. We hope yours will be much longer. However, at the SMWW Agency, we expect the best and prepare for the worst in regards to your financial future. Step one is making sure you are prepared financially for a career after your playing days are over. SMWW is an expert at maximizing your post-playing career opportunities. Step two is making sure the paychecks you make in the NFL last a lifetime.
                            </p>
                            <h2><b>Step by Step Approach to Playing Career Income&nbsp;</b></h2>
                            <p>For many of our clients, this is the first time that they earn a paycheck. You will begin to see that the more money you make, the more taxes you pay. Our first job is to help you with some financial planning so that your personal taxes are as low as possible. Our second job is to set you up on a savings plan. Our third job is to have you work with a trusted financial planner. Through a strategic alliance, we provide guidance towards selected financial advisors, though you have full candidness to use another advisor at your choosing. Please be aware, these financial advisors are paid separately from SMWW.</p>
                            <p>We have a step-by-step process to determine each client's unique situation, visions, financial needs, and long-term goals. Whether it's setting up life insurance, investing in the future, or purchasing your first automobile, SMWW is committed to providing its clients with full support. Professional athletes are vulnerable, and our job is to make sure you don't have to worry about finances. Our goal is that you have money set aside for after your playing days, regardless of how long you play in the NFL.</p>
                            <h2><span><strong>SMWW Agency Financial Services:</strong></span></h2>
                            <p><em>(all of which we guarantee we do not receive a kickback for): </em><strong>&nbsp;</strong></p>
                            <div class="twocoll">
                                <ul>
                                    <li>Relocation Expenses</li>
                                    <li>Financial Planning</li>
                                    <li>Immediate Savings Plans</li>
                                    <li>Retirement Plans</li>
                                    <li>Stocks &amp; Bonds</li>
                                    <li>Estate Planning</li>
                                    <li>Mortgage Planning</li>
                                    <li>Disability Insurance</li>
                                </ul>
                            </div>
                            <div class="twocoll">
                                <ul>
                                    <li>Real Estate Investments</li>
                                    <li>Long-Term Care</li>
                                    <li>Life Insurance</li>
                                    <li>Business Planning</li>
                                    <li>Home &amp; Auto Insurance</li>
                                    <li>Annuities</li>
                                    <li>Mutual Funds</li>
                                    <li>Family &amp; Friends Requesting Loans</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="right">
                        <SalespersonSidebar />
                    </div>
                </div>
            )}
        </>
    );
};
export default AgencyFinancialServices;